/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Container, Flex, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import BreadcrumbComponent from '../../components/BreadcrumbComponent/BreadcrumbComponent';
import ReportLayout from '../../components/Report/NewLayout/ReportLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import c from '../../constant';
import useStore from '../../store';
import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { isPermittedUser } from '../ReportDue/Common/Utils';

function Report() {
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const period = urlParams.get('period') ?? 'monthly';
	const { t } = useTranslation();
	const { push } = useHistory();
	const { currentUser: user } = useStore((state) => state?.currentUser);
	const hasReportDuePermission = useMemo(() => isPermittedUser(user), [user]);

	return (
		<>
			<Container maxW="container.xl" mb="16px">
				<Flex justifyContent="space-between">
					<BreadcrumbComponent
						list={[
							{
								name: 'Insurance Institute Report',
								path: '/company-submission-report',
							},
							{
								name: period,
								path: '/company-submission-report?period=' + period,
							},
						]}
					/>
					<Flex flexDirection="row" alignItems="end">
						{hasReportDuePermission && (
							<Menu>
								<MenuButton cursor="pointer">
									<Button colorScheme="gray" variant="solid" size="xs" borderRadius={c.borderRadius} border="1px solid #bdc3c7">
										<FontAwesomeIcon icon={faEllipsisH} style={{ fontSize: 12 }} />
									</Button>
								</MenuButton>
								<MenuList pt="4" pb="4" pl="3" pr="3" borderRadius={c.borderRadius}>
									<MenuItem onClick={() => push('/company-submission-report/report-due')}>{t('Permission On Report Due...')}</MenuItem>
								</MenuList>
							</Menu>
						)}
					</Flex>
				</Flex>
				<Box pb="32px" w="100%" mt="5">
					<ReportLayout period={period} />
				</Box>
			</Container>
		</>
	);
}

export default Report;
